/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

import { CardColorProps } from '../BaseIcon'

export const Visa: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <g clipPath='url(#visa-v2-a)'>
          <rect width='40' height='24' rx='2' fill='#fff' />
          <path
            d='M34 16.23h-2.18l-.24-1.14c-.02-.16-.08-.22-.25-.21H28.7c-.13 0-.18.04-.22.16l-.39 1.08c-.02.04-.08.11-.12.11h-2.39L26 15.2l3.05-7.3c.22-.52.55-.74 1.12-.74h1.92l.19.88 1.5 7.2.21.93v.06Zm-2.86-3.22-.69-3.32h-.03L29.22 13h1.92ZM24.49 7l.86.16c.26.06.52.15.8.23-.15.65-.28 1.29-.41 1.91-.37-.1-.72-.23-1.08-.31-.49-.1-.99-.15-1.48-.01-.2.05-.4.16-.56.3-.27.23-.27.56-.01.8.17.17.38.3.6.43.47.29.97.54 1.44.85.54.36.94.86 1.03 1.53a2.73 2.73 0 0 1-1.3 2.79c-.62.41-1.33.6-2.07.67a7.41 7.41 0 0 1-3.03-.34l-.2-.08-.07-.04.43-1.98.48.21a4.3 4.3 0 0 0 2.4.3c.21-.04.43-.14.61-.26.4-.26.44-.76.08-1.07-.24-.2-.52-.36-.8-.52-.41-.26-.86-.48-1.26-.77a2.12 2.12 0 0 1-.95-1.5c-.1-.98.26-1.78 1-2.4a4.23 4.23 0 0 1 2.26-.87l.13-.03h1.1ZM16 7.17l-.36.86c-1.12 2.68-2.25 5.36-3.36 8.05-.06.13-.12.16-.25.16H9.9c-.15 0-.2-.05-.23-.18-.6-2.35-1.22-4.7-1.81-7.04a1.21 1.21 0 0 0-.74-.9 11.7 11.7 0 0 0-2.03-.66L5 7.43c0-.27 0-.27.26-.27H9c.58 0 1 .34 1.12.93l.94 4.95c0 .08.02.15.04.25l.07-.13c.77-1.95 1.55-3.9 2.31-5.86.04-.1.1-.14.21-.14H16Zm-.94 9.07L17 7.17h2.35l-.3 1.36c-.52 2.5-1.06 5-1.59 7.49-.03.17-.1.23-.27.22h-2.13Z'
            fill='#1434CB'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
            fill='#F0F0F0'
          />
        </g>
        <defs>
          <clipPath id='visa-v2-a'>
            <rect width='40' height='24' rx='2' fill='#fff' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <g clipPath='url(#visa-v1-a)'>
          <rect width='40' height='24' rx='2' fill='#fff' />
          <path d='M34 16.23h-2.18l-.24-1.14c-.02-.16-.08-.22-.25-.21H28.7c-.13 0-.18.04-.22.16l-.39 1.08c-.02.04-.08.11-.12.11h-2.39L26 15.2l3.05-7.3c.22-.52.55-.74 1.12-.74h1.92l.19.88 1.5 7.2.21.93v.06Zm-2.86-3.22-.69-3.32h-.03L29.22 13h1.92ZM24.49 7l.86.16c.26.06.52.15.8.23-.15.65-.28 1.29-.41 1.91-.37-.1-.72-.23-1.08-.31-.49-.1-.99-.15-1.48-.01-.2.05-.4.16-.56.3-.27.23-.27.56-.01.8.17.17.38.3.6.43.47.29.97.54 1.44.85.54.36.94.86 1.03 1.53a2.73 2.73 0 0 1-1.3 2.79c-.62.41-1.33.6-2.07.67a7.41 7.41 0 0 1-3.03-.34l-.2-.08-.07-.04.43-1.98.48.21a4.3 4.3 0 0 0 2.4.3c.21-.04.43-.14.61-.26.4-.26.44-.76.08-1.07-.24-.2-.52-.36-.8-.52-.41-.26-.86-.48-1.26-.77a2.12 2.12 0 0 1-.95-1.5c-.1-.98.26-1.78 1-2.4a4.23 4.23 0 0 1 2.26-.87l.13-.03h1.1ZM16 7.17l-.36.86c-1.12 2.68-2.25 5.36-3.36 8.05-.06.13-.12.16-.25.16H9.9c-.15 0-.2-.05-.23-.18-.6-2.35-1.22-4.7-1.81-7.04a1.21 1.21 0 0 0-.74-.9 11.7 11.7 0 0 0-2.03-.66L5 7.43c0-.27 0-.27.26-.27H9c.58 0 1 .34 1.12.93l.94 4.95c0 .08.02.15.04.25l.07-.13c.77-1.95 1.55-3.9 2.31-5.86.04-.1.1-.14.21-.14H16Zm-.94 9.07L17 7.17h2.35l-.3 1.36c-.52 2.5-1.06 5-1.59 7.49-.03.17-.1.23-.27.22h-2.13Z' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          />
        </g>
        <defs>
          <clipPath id='visa-v1-a'>
            <rect width='40' height='24' rx='2' fill='#fff' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
  </React.Fragment>
)
